var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "10px",
    viewBox: "0 0 15 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "left-arrow-key@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MULTI-LOCATION-REPORTS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3-Multi-location-Reports--Product-mix",
    transform: "translate(-1267.000000, -1294.000000)",
    fill: "#0080DE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(274.000000, 1171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left-arrow-key",
    transform: "translate(1000.500000, 128.000000) scale(-1, 1) translate(-1000.500000, -128.000000) translate(993.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "14.6153846 4.16666667 3.08547009 4.16666667 6.00854701 1.16666667 4.87179487 0 0 5 4.87179487 10 6.00854701 8.83333333 3.08547009 5.83333333 14.6153846 5.83333333"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowKey);
export default __webpack_public_path__ + "static/media/right-arrow-key.fedf593bec0311468e630ea5db30c52c.svg";
export { ForwardRef as ReactComponent };